import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
	uri: 'https://strapi.stage.openeconomics.dol.dev/graphql',
	cache: new InMemoryCache(),
});

export default client;
